import React from 'react';

type Props = {
  col: { select: string; severity: string; date: string; customer: string; summary: string; complaint: string; vulnerability: string; chevron: string };
};

const ConductFeedSkeleton: React.FC<Props> = ({ col }) => {
  return (
    <div className="flex flex-col h-full bg-white">
      <div className="px-6 py-4 border-b border-[#F4F4F4]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-[26px] w-12 bg-gray-200 rounded-full animate-pulse" />
            <div className="h-[26px] w-20 bg-gray-200 rounded-full animate-pulse" />
            <div className="h-[26px] w-24 bg-gray-200 rounded-full animate-pulse" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-[35px] w-[110px] bg-gray-200 rounded-[20px] animate-pulse" />
            <div className="h-[35px] w-[90px] bg-gray-200 rounded-[20px] animate-pulse" />
            <div className="h-[35px] w-[240px] bg-gray-200 rounded-[20px] animate-pulse" />
          </div>
        </div>
      </div>

      <div className="bg-[#F7F7F7] h-10 flex items-center px-6 border-b border-[#F4F4F4] text-[10px] font-semibold uppercase tracking-wider text-[rgba(38,38,40,0.6)]">
        <div className={col.select} />
        <div className={col.severity}>Severity</div>
        <div className={col.date}>Date</div>
        <div className={col.customer}>Customer Name</div>
        <div className={col.summary}>Summary</div>
        <div className={col.complaint}>Complaint</div>
        <div className={col.vulnerability}>Vulnerability</div>
        <div className={col.chevron} />
      </div>

      <div className="flex-1 overflow-y-auto px-6 pb-6">
        {Array.from({ length: 8 }).map((_, idx) => (
          <div key={idx} className={`${idx % 2 === 1 ? 'bg-[rgba(244,244,244,0.5)]' : ''} border-b border-[#F4F4F4]`}>
            <div className="flex items-center h-[64px] px-6">
              <div className={col.select}>
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={`${col.severity} flex items-center`}>
                <div className="w-6 h-6 rounded-full bg-gray-200 animate-pulse" />
              </div>
              <div className={`${col.date}`}>
                <div className="h-3 w-20 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={`${col.customer}`}>
                <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={`${col.summary}`}>
                <div className="h-3 w-full bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={`${col.complaint}`}>
                <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={`${col.vulnerability}`}>
                <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
              </div>
              <div className={col.chevron}>
                <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(ConductFeedSkeleton);
